<template>
  <div :id="$style.saying_list">
    <b-button :class="$style.button" @click="goPrev" :href="'#' + list_num">
      <div :class="$style.up_arrow"></div>
    </b-button>
    <ul>
      <li
        :class="{
          [$style.list]: true,
          [$style.active]: xlength - 1 - index == xactive,
        }"
        v-for="(item, index) in x.slice().reverse()"
        :key="item.id_number"
        :id="index"
        @click="changeActive(xlength - 1 - index)"
      >
        <span>{{ xlength - index }}</span>
        {{ item.short }}
      </li>
    </ul>
    <b-button :class="$style.button" @click="goNext" :href="'#' + list_num"
      ><div :class="$style.down_arrow"></div
    ></b-button>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
// import hlist from "@/assets/json/saying/sentiment.json";
import { Saying } from "@/api"

export default Vue.extend({
  name: "SayingListVisual",
  data() {
    return {
      // hlist,
      // hlength: hlist["sentiment"].length,
      // active: hlist["sentiment"].length - 1 ,
      list_num: 0,
      x: [],
      xlength: 0,
      xactive: 0,
    };
  },

  mounted() {
    Saying.getNumberOfItems().then(({count}) => {
      Saying.getAllList(count).then(({results})=>{
        this.xlength = count;
        this.xactive = count - 1
        this.x = results.reverse()
        this.$emit("child_event", this.x[this.xactive])
      });
    });
  },
  methods: {
    changeActive(index) {
      // this.active = index;
      // this.$emit("child_event", this.hlist["sentiment"][this.active]);
      this.xactive = index
      this.$emit("child_event", this.x[this.xactive]);
    },
    goPrev() {
      this.list_num -= 10;
      if (0 > this.list_num) {
        this.list_num = 0;
      }
      // this.active = this.hlength - 1 - this.list_num;
      this.xactive = this.xlength - 1 - this.list_num;
    },
    goNext() {
      this.list_num += 10;
      // if (this.hlength - 1 <= this.list_num) {
        // this.list_num = this.hlength - 10;
      // }
      if (this.xlength - 1 <= this.list_num) {
        this.list_num = this.xlength - 10;
      }
      // this.active = this.hlength - 1 - this.list_num;
      this.xactive = this.xlength - 1 - this.list_num;
    },
    getItems (){
      return [{full:1},{full:1},{full:1}]
    }
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #saying_list {
    width: 100%;
    min-height: 300px;
    background: #cacede;
    justify-content: center;
    align-content: center;
    .button {
      opacity: 0;
      height: 0;
      width: 0;
      padding: 0;
      border: 0;
    }
    ul {
      display: flex;
      flex-direction: row;
      overflow: scroll;
      overflow-y: hidden;
      padding: 0;
      margin: 0;
      font-size: 12.5px;
      height: 280px;
      // min-width: 320px;

      .list {
        width: 45px;
        height: 320px;
        margin: 0 15px;
        margin-top: 4px;
        padding: 0px 11px;
        padding-top: 10px;
        background: #fff;
        list-style-type: none;
        writing-mode: vertical-rl;
        cursor: pointer;
        span {
          writing-mode: horizontal-tb;
          margin-right: 1px;
          font-weight: 700;
        }
        &:hover {
          background: rgba(#848484, 0.6);
        }
      }
      .active {
        color: #fff;
        background: #848484;
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  #saying_list {
    width: 35%;
    min-height: 350px;
    background: #cacede;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    .button {
      display: flex;
      justify-content: center;
      width: 100px;
      height: 20px;
      padding: 5px;

      .up_arrow {
        width: 10px;
        height: 10px;
        border: 5px solid;
        border-color: #ffffff #ffffff transparent transparent;
        transform: rotate(-45deg);
      }
      .down_arrow {
        width: 10px;
        height: 10px;
        border: 5px solid;
        border-color: #ffffff #ffffff transparent transparent;
        transform: rotate(135deg);
      }
    }
    ul {
      display: block;
      overflow: scroll;
      padding: 0px;
      margin: 10px 0px;
      height: 535px;
      .list {
        width: 340px;
        line-height: 40.5px;
        margin: 13px 15px;
        justify-content: center;
        margin-top: 10px;
        padding-left: 11px;
        background: #fff;
        list-style-type: none;
        cursor: pointer;
        span {
          writing-mode: horizontal-tb;
          margin-right: 1px;
          font-weight: 700;
        }
        &:hover {
          background: rgba(#848484, 0.6);
        }
      }
      .active {
        color: #fff;
        background: #848484;
      }
    }
  }
}
</style>
